import { render, staticRenderFns } from "./KioskCompare.vue?vue&type=template&id=736bb0a4"
import script from "./KioskCompare.vue?vue&type=script&lang=js"
export * from "./KioskCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports